import React from 'react';
import Header from '../../header/header';
import Footer from '../../footer/footer';
import DeuilGallery from './deuilgallery';

const Deuil = (props) => {

  return (
    <div>  
            <Header />

    <div id="activites">

      <div className="container">
                   <div className="col-xs-12 col-md-12">
<br></br>
<br></br>
        <div className="section-title">

          <h2>Deuil</h2>
             
        </div>
        <div className="activites-list">
       
        <h3>Événements cultuels et commémoratifs</h3>
<br></br>
        <p>
        Dans les moments les plus délicats, les fleurs offrent un langage sincère pour exprimer l’amour, le respect et le souvenir. 
        <br></br>Notre collection de pièces de deuil est pensée avec sensibilité et élégance, afin d’accompagner chaque hommage avec douceur.
        </p>

        <p>
Couronnes, gerbes, coussins ou compositions personnalisées, chaque création est réalisée à la main avec des fleurs fraîches soigneusement sélectionnées. 
<br></br>Nous vous accompagnons avec discrétion pour concevoir un arrangement fidèle à vos intentions et à la mémoire de l’être cher.        </p>

<p>Parce que chaque au revoir mérite une attention unique, nous mettons notre savoir-faire de fleuriste au service de vos émotions.</p>
<br></br>
<DeuilGallery />


</div>
      </div>
      </div>
  </div>
      < Footer />

    </div>

  );
};
export default Deuil;